<template>
	<div id="video_player_wrapper">
    <video 
    ref="videoPlayer"
     class="video-js" 
     :poster="poster"
     ></video>
  </div>
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css'
//import '@/assets/playerskin.css'
export default {

  name: 'VideoPlayer',
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    internalduration:{
    	type:Number,
    	default:3000,
    },
    userprogress:{
    	type:Number,
    	default:0,
    },
    keepproggresstrack:{
    	type:Boolean,
    	default:false,
    }
  },
  data () {
    return {
    	player: null,
    	internalobj:null,
    	videoprogress:0,
    	poster:null,
    	trposter:require('../../assets/baslamak_icin_tiklayin.jpg'),
    	eng_poster:require('../../assets/click_to_play.jpg')
    }
  },
  computed:{
  	preflang()
  	{
  		return this.$store.state.auth.user.preflang_id==3
  	},
  },
  watch:{
  	preflang(newvalioldval)
  	{
      
  		this.adjustPoster()
      //this.restartVideo()
  	}
  },
  mounted() {
  	if(this.userprogress)
  	{
  		this.videoprogress = this.userprogress
  	}

    //adjust volume
    let volume = localStorage.getItem("vrfyhb_vid_vol");
    if(!volume)
    {
      volume = 1
      localStorage.setItem("vrfyhb_vid_vol",1);
    }
    //adjust volume


    this.player = videojs(this.$refs.videoPlayer, this.options, () => {
    //this.player.log('onPlayerReady', this);
    console.log("RANGE CHECK")
    console.log(this.options.sources[0].src)
    this.player.play()
    this.$refs.videoPlayer.volume = volume
    });
    

    this.player.on("playing",(data)=>{
    	//console.log("playing")
    	if(this.keepproggresstrack)
    	{
    		clearInterval(this.intervalobj);
	    	this.intervalobj = setInterval(()=>{
	  			this.$emit("durationChanged",Math.ceil(this.player.currentTime()))  			
	  			if (this.videoprogress < this.player.currentTime()) {
			        this.videoprogress = Math.ceil(this.player.currentTime())
			      }
	  		},this.internalduration)
    	}
    	
    })
    this.player.on("pause",(data)=>{
    	if(this.keepproggresstrack)
    	{
    		clearInterval(this.intervalobj);
    	}
    	
    })
    this.player.on("ended",(data)=>{
    	//this.player.webkitExitFullScreen();
    	if(this.keepproggresstrack)
    	{
    		clearInterval(this.intervalobj);
    	}
    	this.$emit("playEnded") 
    })

    this.player.on("seeking",(data)=>{
    	//console.log(this.videoprogress)
    	//console.log(this.player.currentTime())
    	 if (this.videoprogress < this.player.currentTime()) {
	        this.player.currentTime(this.videoprogress)
	      }
    })
    this.player.on("seeked",(data)=>{
    	 if (this.videoprogress < this.player.currentTime()) {
	        this.player.currentTime(this.videoprogress)
	      }
    })
    this.player.on("timeupdate",(data)=>{
    	//console.log("timeupdate");
    	//console.log(this.player.currentTime());

    })
    this.player.on("volumechange",(data)=>{
     
      localStorage.setItem("vrfyhb_vid_vol",data.target.player.controlBar.volumePanel.volumeControl.volumeBar.progress_);
    })
    setTimeout(()=>{
    	this.adjustPoster()
    },10)
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
  methods:{
    restartVideo()
    {
      //this.$refs.videoPlayer.pause()
      console.log("forceupdate")
      console.log(this.options.sources[0].src)
      this.$forceUpdate();
      
    },
  	adjustPoster()
  	{
  		
  		if(this.$store.state.auth.user.preflang_id==3)
  		{
  			this.poster = this.trposter
  			this.player.poster = this.trposter
  		}
  		else
  		{
  			this.poster=this.eng_poster
  			this.player.poster = this.eng_poster
  		}
  	}
  },
}
</script>

<style lang="css">
	.video-js .vjs-big-play-button{
  display: none;
}
</style>